<template>
  <div class="d-flex flex-column">
    <subnav :links="subnav" heading="Модемы"/>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
  export default {
    metaInfo: {title: 'Модемы'},
    data: () => ({
      subnav: [
        {
          text: 'Активные',
          to: '/modems',
          exact: true,
        },
        {
          text: 'Удаленные',
          to: '/modems/deleted',
        },
        {
          text: 'Рассылки',
          to: '/modems/broadcasts',
          adminOnly: true,
        },
      ],
    }),
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/modems/index.vue